import React, { useEffect, useState } from 'react';
import TalentcheckModule from '../components/TalentcheckModule';
import '../css/global.css';

function Praxismodul1() {
  const module = "Praxismodul1"; const role = sessionStorage.getItem('role'); // Rolle aus sessionStorage lesen

  if (!role) {
    console.error("Role ist nicht im sessionStorage gesetzt.");
    return <div>Fehler: Keine Rolle gesetzt.</div>;
  }

  return (
    <div>
      <TalentcheckModule
        status={role} // Rolle als Status an TalentcheckModule übergeben
        module={module} // Modulname als Parameter weitergeben
      />
    </div>
  );
}

export default Praxismodul1;